(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("debug"), require("fs"), require("purdy"), require("request-promise"), require("node-forge"), require("zlib"));
	else if(typeof define === 'function' && define.amd)
		define(["debug", "fs", "purdy", "request-promise", "node-forge", "zlib"], factory);
	else if(typeof exports === 'object')
		exports["chromecast-discover"] = factory(require("debug"), require("fs"), require("purdy"), require("request-promise"), require("node-forge"), require("zlib"));
	else
		root["chromecast-discover"] = factory(root["debug"], root["fs"], root["purdy"], root["request-promise"], root["node-forge"], root["zlib"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition